import { TranslatorContext } from '@/contexts/translator'
import type { Translator } from '@/util/translate/translator'
import { useContext } from 'react'

export function useTranslator(): Translator {
	const translator = useContext(TranslatorContext)
	if (!translator) throw new Error('Running outside TranslatorContext')
	return translator
}
